import { render, staticRenderFns } from "./RecentlyViewedProducts.vue?vue&type=template&id=73dc1970&scoped=true&"
import script from "./RecentlyViewedProducts.vue?vue&type=script&lang=js&"
export * from "./RecentlyViewedProducts.vue?vue&type=script&lang=js&"
import style0 from "./RecentlyViewedProducts.vue?vue&type=style&index=0&id=73dc1970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dc1970",
  null
  
)

export default component.exports